var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfloat table-top"},[_c('div',{attrs:{"id":"title"}},[_vm._v("\n    "+_vm._s(_vm.$store.state.nowActiveTitle)+"\n    "),_vm._t("title")],2),_vm._v(" "),_c('div',{attrs:{"id":"searchTop"}},[_vm._t("search")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32d38bf8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/src/components/sys/reportTop.vue
// module id = null
// module chunks = 